module.exports = __webpack_public_path__ + "img/vg.b090c451.svg";